import React, { useState, useEffect, useContext } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Stack,
  Box,
} from "@mui/material";
import { getRuta, simpleMessage } from "../../../../helpers/Helpers";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getSucursalByUserAsync } from "../../../../api/Users";
import { getToken } from "../../../../api/Account";
import { DataContext } from "../../../../context/DataContext";
import { accionPrincipalSx } from "../../../../components/ui/accionPrincipal";

const SelectorClientsGestor = () => {
  const [selectedStatus, setSelectedStatus] = useState(2);

  const [sucursalList, setSucursalList] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState("t");

  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  let ruta = getRuta();

  useEffect(() => {
    getSucursals();
  }, []);

  const verReport = () => {
    var params = `${selectedSucursal}/${selectedStatus}`;
    window.open(`${ruta}/r-clientsgestor/${params}`);
  };

  const token = getToken();

  const getSucursals = async () => {
    setIsLoading(true);
    const result = await getSucursalByUserAsync(token);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }
    setIsLoading(false);
    setSucursalList(result.data.result);
  };

  return (
    <div>
      <Box sx={{ width: '100%', maxWidth: 550 }}>
        <Stack spacing={2}>
          <FormControl fullWidth style={{ textAlign: "left" }}>
            <InputLabel id="demo-simple-select-standard-label">
              Sucursal
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              onChange={(e) => setSelectedSucursal(e.target.value)}
              value={selectedSucursal}
              label="Sucursal"
            >
              {sucursalList.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.description}
                  </MenuItem>
                );
              })}

              <MenuItem key={"t"} value={"t"}>
                TODAS...
              </MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth style={{ textAlign: "left" }}>
            <InputLabel id="demo-simple-select-standard-label">
              Estado del Cliente
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              onChange={(e) => setSelectedStatus(e.target.value)}
              value={selectedStatus}
              label=" Estado del Cliente"
              style={{ textAlign: "left" }}
            >
              <MenuItem value="">
                <em>Seleccione una Opción</em>
              </MenuItem>

              <MenuItem key={0} value={0}>
                ACTIVOS
              </MenuItem>
              <MenuItem key={1} value={1}>
                INACTIVOS
              </MenuItem>
              <MenuItem key={2} value={2}>
                TODOS...
              </MenuItem>
            </Select>
          </FormControl>

          <Button
            variant="contained"
            startIcon={
              <FontAwesomeIcon icon={faPrint} />
            }
            onClick={() => verReport()}
            sx={accionPrincipalSx}
          >
            Generar Reporte
          </Button>
        </Stack>
      </Box>
    </div>
  );
};

export default SelectorClientsGestor;
